import ParkItem from '@/components/ParkItem';

export default function ParkItemsGrid({
  items,
  showDistance,
  gridClassNames,
  isListView,
  compact = false,
}) {
  const defaultClasses =
    'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 my-5';

  return (
    <ul className={gridClassNames || defaultClasses}>
      {items &&
        items.map((park) => (
          <li key={park.id} id={`park-${park.id}`}>
            <ParkItem
              park={park}
              showDistance={showDistance}
              isListView={isListView}
              compact={compact}
            />
          </li>
        ))}
    </ul>
  );
}
